module.exports = __webpack_public_path__ + "static/img/Gini-product-3.2c4403c.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Gini-product-3.png
// module id = EduU
// module chunks = 1